export default __webpack_public_path__ + "static/Gem_hunter-d33c1177c4e1ce5fb0ffd6e7cb20afb2.png";